var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.44413 0.166656H3.55579C1.43246 0.166656 0.166626 1.43249 0.166626 3.55582V8.43832C0.166626 10.5675 1.43246 11.8333 3.55579 11.8333H8.43829C10.5616 11.8333 11.8275 10.5675 11.8275 8.44416V3.55582C11.8333 1.43249 10.5675 0.166656 8.44413 0.166656Z",
    fill: "#0A8F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76966 3.08334H5.95216C5.71299 3.08334 5.51466 3.28168 5.51466 3.52084C5.51466 3.76001 5.71299 3.95834 5.95216 3.95834H7.71383L3.21049 8.46168C3.04133 8.63084 3.04133 8.91084 3.21049 9.08001C3.29799 9.16751 3.40883 9.20834 3.51966 9.20834C3.63049 9.20834 3.74133 9.16751 3.82883 9.08001L8.33216 4.57668V6.33834C8.33216 6.57751 8.53049 6.77584 8.76966 6.77584C9.00883 6.77584 9.20716 6.57751 9.20716 6.33834V3.52084C9.20716 3.28168 9.00883 3.08334 8.76966 3.08334Z",
    fill: "#0A8F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpGreen);
export default __webpack_public_path__ + "static/media/IconUpGreen.f7b1c6dbfc0475b8ca0b0f500bc565ee.svg";
export { ForwardRef as ReactComponent };